import React from "react";
import Header from "../../components/header";

const PrivacyPolicy = () => {
  return (
    <>
      <Header></Header>
      <div className="max-w-3xl mx-auto px-4 py-10 text-gray-800">
        <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>
        <p className="text-sm text-gray-500 mb-8">
          Effective date: April 17, 2024
        </p>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-2">1. Who We Are</h2>
          <p>
            BookishBoyfriend ("BB") provides an interactive reading and AI chat
            platform. We act as <strong>controller</strong> of your personal
            data under EU/UK GDPR and as a <strong>business</strong> under the
            CCPA/CPRA.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-2">2. Scope</h2>
          <p>
            This Policy explains how we collect, use, share, and protect
            information of visitors and registered users in the United States,
            United Kingdom, European Economic Area, and elsewhere.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-2">3. Data We Collect</h2>
          <ul className="list-disc pl-5 space-y-1 !marker-blue-500">
            <li>
              <strong>Account Data:</strong> name, email, username, password
              hash – to create / secure your account.
            </li>
            <li>
              <strong>Usage Data:</strong> page views, chat prompts, token
              counts, device info, IP address – to operate, secure, and improve
              the Service.
            </li>
            <li>
              <strong>Payment Data:</strong> last 4 digits of card, billing
              address (processed by Stripe/PayPal) – to manage subscriptions.
            </li>
            <li>
              <strong>Communications:</strong> support tickets, survey responses
              – to respond to you and improve service.
            </li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-2">
            4. How We Use Data & Legal Bases (UK/EU)
          </h2>
          <ul className="list-disc pl-5 space-y-1">
            <li>
              <strong>Provide the Service </strong>(Contract)
            </li>
            <li>
              <strong>Improve and develop</strong> (Legitimate Interest)
            </li>
            <li>
              <strong>Marketing with consent</strong> (Consent – unsubscribe any
              time)
            </li>
            <li>
              <strong>Protect rights and comply with law</strong> (Legal
              Obligation)
            </li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-2">
            5. Sharing & Disclosure
          </h2>
          <p>
            We share data only with:
            <ul className="list-disc pl-5 space-y-1">
              <li>
                Cloud hosting, analytics, and payment vendors who process data
                on our behalf under data-processing agreements.
              </li>
              <li>
                We may disclose to authorities when required by law or to
                protect safety, rights, or property. We do <strong>not</strong>{" "}
                sell your personal data.
              </li>
            </ul>
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-2">
            6. International Transfers
          </h2>
          <p>
            Data may be processed in the US and other countries. For transfers
            from the UK/EEA we rely on{" "}
            <strong>EU Standard Contractual Clauses (SCCs)</strong> and the UK
            Addendum.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-2">7. Cookies & Tracking</h2>
          <p>
            We use essential cookies for authentication and security, analytics
            cookies to understand usage, and advertising cookies (Meta, Google)
            with your consent. Manage preferences in the Cookie Banner.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-2">8. Your Rights</h2>
          <ul className="list-disc pl-5 space-y-1">
            <li>
              <strong>EEA/UK:</strong> Access, rectify, erase, restrict,
              portability, object, and lodge a complaint with your supervisory
              authority.
            </li>
            <li>
              <strong>California:</strong> Know, delete, correct, opt out of
              "sale/share"; we honour Global Privacy Control signals.
            </li>
            <li>
              <strong>All users: </strong>Withdraw consent at any time.
            </li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-2">9. Security</h2>
          <p>
            We use HTTPS, encryption at rest, least-privilege access, and
            regular security reviews. No system is 100% secure; please use
            unique passwords and enable any offered MFA.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-2">10. Data Retention</h2>
          <p>
            We retain personal data only as long as necessary to operate
            BookishBoyfriend, fulfill the purposes outlined in this Policy, and
            comply with legal obligations.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-2">11. Children</h2>
          <p>
            BB is not directed at children under 13 (US) / 16 (EEA/UK). If we
            learn we have collected data from such children without parental
            consent we will delete it.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-2">
            12. Changes to This Policy
          </h2>
          <p>
            We may update this Policy. Material changes will be notified by
            email or in-app.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-2">13. Contact Us</h2>
          <p>
            <a
              href="mailto:privacy@bookishboyfriend.com"
              className="text-blue-600 hover:underline"
            >
              privacy@bookishboyfriend.com
            </a>{" "}
            | Data Protection Officer, McAnders Publishing LLC, Encino,
            California, USA
          </p>
        </section>

        <footer className="text-xs text-gray-400 mt-10">
          &copy; {new Date().getFullYear()} McAnders Publishing LLC. All rights
          reserved.
        </footer>
      </div>
    </>
  );
};

export default PrivacyPolicy;
